import { NAV_LINKS } from "@/data/content";

const LEGAL = [
  { label: "Impressum", href: "#impressum" },
  { label: "Datenschutz", href: "#datenschutz" },
  { label: "Kontakt", href: "#kontakt" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0a0c12]" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        {/* top */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 py-16">
          <div className="lg:col-span-5">
            <span className="font-display text-2xl font-extrabold tracking-tight text-white">
              Cash<span className="text-[#e01e37]">FUX</span>
            </span>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/45">
              Banking-Infrastruktur für moderne Unternehmen. White-Label-Konten,
              Wallets, Karten, Payments und APIs in einer Plattform.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 border border-white/10 px-3 py-1.5">
              <span className="h-1.5 w-1.5 bg-emerald-400" />
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50">
                Compliance Ready
              </span>
            </div>
          </div>

          <div className="lg:col-span-4 lg:col-start-7">
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/35">
              Navigation
            </span>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-nav-${l.href.replace("#", "")}`}
                    className="text-sm text-white/55 hover:text-white transition-colors duration-300"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/35">
              Rechtliches
            </span>
            <ul className="mt-5 space-y-3">
              {LEGAL.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-legal-${l.href.replace("#", "")}`}
                    className="text-sm text-white/55 hover:text-white transition-colors duration-300"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* bottom */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/10 py-8">
          <p className="font-mono text-xs text-white/35">
            © {new Date().getFullYear()} CashFUX. Alle Rechte vorbehalten.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/30">
            White Label · API First · Multi-Currency
          </p>
        </div>
      </div>
    </footer>
  );
}
